<template>
    <div class="bianliuqi">
        <Title firstName="变流器概况" lastName="CONVERTER PROFILE" />
        <div class="content">
            <div class="tab" @click="tabList">
                开机 | 正常工作
                <p>{{bianliuName}} <i class="el-icon-arrow-down"></i></p>
            </div>
            <div class="list" v-show="showList">
                <SelectList :selectList="loopList" @tabTitle="tabTitle" keyk="id" keyval="value"/>
            </div>
            <div class="loopTable">
                <table>
                    <tr>
                        <td></td>
                        <td>A相</td>
                        <td>B相</td>
                        <td>C相</td>
                        <td>总</td>
                    </tr>
                    <tr>
                        <td>电网电流(A)</td>
                        <td>242.70</td>
                        <td>242.54</td>
                        <td>242.68</td>
                        <td>--</td>
                    </tr>
                    <tr>
                        <td>电网电压(V)</td>
                        <td>412.21</td>
                        <td>412.63</td>
                        <td>242.68</td>
                        <td>--</td>
                    </tr>
                    <tr>
                        <td>直流电流(A)</td>
                        <td>--</td>
                        <td>--</td>
                        <td>--</td>
                        <td>138.8</td>
                    </tr>
                    <tr>
                        <td>直流电压(V)</td>
                        <td>--</td>
                        <td>--</td>
                        <td>--</td>
                        <td>720</td>
                    </tr>
                </table>
            </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
const Title = () => import('../../../components/title/Title')
const SelectList = () => import('../../../components/title/selectList')
export default {
    data(){
        return {
            isShow:true,
            bianliuName:'1#变流器',
            showList:false,
            loopList:[
                {
                    id:1,
                    value:'1#变流器',
                },
            ]
        }
    },
    watch: {
    },
    components:{
        Title,SelectList
    },
    mounted(){
    },
    methods:{
        tabList(){
             this.showList = !this.showList
        },
        tabTitle(bian){
            this.bianliuName = bian.value
            this.showList = false
        }
    }
}
</script>

<style lang="less" scoped>
    .bianliuqi{
        height: 33.3vh;
        width: 20vw;
        position: fixed;
        top: 37.8vh;
        right: 1vw;

        .content{
            position: relative;
            height: 25vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);

            .tab{
                height: 3.3vh;
                line-height: 3.3vh;
                font-size: 14rem;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: rgba(230,243,253, 0.7);
                padding-left:0.8vw ;
                p{
                    position: absolute;
                    right: 1vh;
                    top: 0;
                    cursor: pointer;
                }
            }

            .list{
                height: 10.5vh;
                width: 100%;
                position: absolute;
                left: 0;
                top: 3.5vh;
                z-index: 11;
            }

            .loopTable{
                height: 20.7vh;
                table{
                    width: 100%;
                    height: 100%;
                    border-collapse: collapse;
                    tr{
                        width: 100%;
                        height: 4vh;
                        line-height: 4vh;
                        font-size: 14rem;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: rgba(230,243,253, 0.7);
                        td{
                            text-align: center;
                            width: 20%;
                        }
                    }
                    tr:nth-child(odd){
                        background-color: rgba(164,209,255, 0.12);
                    }
                    tr{
                        td:nth-child(even){
                            background-color: rgba(164,209,255, 0.12);
                        }
                    }
                    tr:nth-child(2),tr:nth-child(3),tr:nth-child(4),tr:nth-child(5){
                        td:nth-child(2),td:nth-child(3),td:nth-child(4),td:nth-child(5){
                            font-size: 18rem;
                            font-family: zcoolqingkehuangyouti;
                            font-weight: 400;
                            color: #00DEFF;
                        }
                    }
                }
            }
            
            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }

        
    }

</style>